import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { FaUserShield } from 'react-icons/fa';
import '../styles/admins.scss';

export const Admins = () => {
    const user = useSelector((state) => state.userController.user);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/login');
        }
    }, [user, navigate]);

    return (
        <section className="admins-page">
            <div className="empty-state">
                <FaUserShield className="icon" />
                <h2>المسؤولين</h2>
                <p>هذه الصفحة قيد الإعداد وستتوفر قريباً</p>
            </div>
        </section>
    );
};

export default Admins;
